import {
  DistrictsResponse,
  ProvincesResponse,
  SubDistrictsResponse,
} from 'types/APIResponsesTypes';
import { APIClient } from 'services/helpers/api_helper';
import * as url from 'services/helpers/url_helper';

// import { AxiosResponse } from 'axios';

const api = new APIClient();

export const getProvinces = async () => {
  try {
    const response: Promise<ProvincesResponse> = await api.get(
      url.GET_PROVINCES
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getDistricts = async (province_id: number) => {
  try {
    const response: Promise<DistrictsResponse> = await api.get(
      url.GET_DISTRICTS,
      { province_id }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getSubDistricts = async (district_id: number) => {
  try {
    const response: Promise<SubDistrictsResponse> = await api.get(
      url.GET_SUBDISTRICTS,
      { district_id }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getTISIProvinces = async () => {
  try {
    const response: Promise<ProvincesResponse> = await api.get(
      url.GET_TISI_PROVINCES
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getTISIDistricts = async (province_id: number) => {
  try {
    const response: Promise<DistrictsResponse> = await api.get(
      url.GET_TISI_DISTRICTS,
      { province_id }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getTISISubDistricts = async (district_id: number) => {
  try {
    const response: Promise<SubDistrictsResponse> = await api.get(
      url.GET_TISI_SUBDISTRICTS,
      { district_id }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
